// extracted by mini-css-extract-plugin
export default {"container":"Button_container__pL88L","primary":"Button_primary__2+HiN","secondary":"Button_secondary__7XEbb","disabled":"Button_disabled__T3gY3"};